// Event QR presentation assets shared by all QR print pages.
// Loads voting settings and optional sponsor logos; sponsor denial never blocks
// printing. Scope state/cancellation to eventId so navigation cannot reuse assets.
import { useEffect, useState } from "react";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { logger } from "../utils/logger";

export const useQrPrintAssets = (eventId) => {
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!eventId) return;
    let active = true;
    setState(null);
    const load = async () => {
      try {
        const [settingsSnap, sponsorsSnap] = await Promise.all([
          getDoc(doc(db, "events", eventId, "settings", "voting")),
          getDocs(collection(db, "events", eventId, "sponsors")).catch((error) => {
            console.warn("[LGV QR Print] Sponsors unavailable. Continuing without sponsor logos.", { code: error.code });
            return null;
          }),
        ]);
        const settings = settingsSnap.exists() ? settingsSnap.data() : {};
        if (active) setState({
          eventId, loading: false, error: "",
          eventImage: settings.eventImage || null, eventLogo: settings.eventLogo || null,
          useImageOnQr: settings.useImageOnQr !== false,
          sponsors: sponsorsSnap?.docs.map((record) => record.data()) || [],
          topLevels: (Array.isArray(settings.sponsorLevels) ? settings.sponsorLevels : []).slice(0, 2).map((level) => level.name),
        });
      } catch (error) {
        logger.error("QR Print failed to load presentation settings", { value: error });
        if (active) setState({ eventId, loading: false, error: "Error loading QR settings." });
      }
    };
    load();
    return () => { active = false; };
  }, [eventId]);
  return state && state.eventId === eventId ? state : { loading: true, error: "" };
};
